import { useState } from 'react'
import { useAlert } from 'react-alert'

import { deleteService } from '../../../main/usecases'
import alertImage from '../../assets/images/alert.gif'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import { Button } from '..'
import { DeleteStyled } from './styles'
import { ServiceModel } from '../../../domain/models'

type ModalProps = {
  item: any
  setServicesList?: (e: any) => void
}

const DeleteServiceModal = ({ item, setServicesList }: ModalProps) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteService = async (id: number) => {
    try {
      if (setServicesList) {
        setServicesList((prev: ServiceModel[]) => {
          return prev.filter((el: ServiceModel) => el.cdServico !== id)
        })
      }
      setLoading(true)
      await deleteService({
        id: id
      }).delete()
      modalClose(true)
      alert.show('Serviço deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })

      setRefresh((prev: any) => !prev)
    } catch (error: any) {
      modalClose(true)
      setRefresh((prev: any) => !prev)
      if (error.statusCode === 409) {
        alert.show(
          'Exclua os registros do serviço antes de realizar a exclusão do serviço',
          {
            type: 'error',
            timeout: 7000
          }
        )
      } else {
        alert.show('Erro ao deletar um serviço', {
          type: 'error',
          timeout: 4000
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <DeleteStyled className="delete-modal">
      <img src={alertImage} />
      <div className="content">
        <p>
          Deseja realmente deletar o serviço? Essa ação não poderá ser
          revertida.
        </p>
        <div className="actions">
          <Button
            hasredButton
            onClick={() => {
              handleDeleteService(item.cdServico)
            }}
            disabled={loading}
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>
    </DeleteStyled>
  )
}

export default DeleteServiceModal
